import { render, staticRenderFns } from "./FileUploadDialog.vue?vue&type=template&id=38ea4a13&scoped=true&"
import script from "./FileUploadDialog.vue?vue&type=script&lang=js&"
export * from "./FileUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadDialog.vue?vue&type=style&index=0&id=38ea4a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea4a13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ea4a13')) {
      api.createRecord('38ea4a13', component.options)
    } else {
      api.reload('38ea4a13', component.options)
    }
    module.hot.accept("./FileUploadDialog.vue?vue&type=template&id=38ea4a13&scoped=true&", function () {
      api.rerender('38ea4a13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/CustomModules/FileUploadDialog.vue"
export default component.exports